import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import cn from 'classname';
import { Link } from 'react-router';

import noop from 'lodash/noop';

import Pagination from '../../../../shared/pagination';
import { getCurrencyIcon } from '../../../../../../../shared/js/get-currency-icon';
import { formatMoney } from '../../../../shared/format';

const propTypes = {
	table: PropTypes.object,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	showMoreRows: PropTypes.func,
	gotoPage: PropTypes.func,
	pagination: PropTypes.object
};

const Table = ({
	table,
	intl,
	sortByColumn,
	pagination,
	gotoPage
}) => {
	return (
		<div className="table-container payout-log-payouts-table-container">
			<table className="simple-table payout-log-payouts-table">
				<thead className="simple-table__head font-roboto-medium">
					<tr>
						{table.headers.map((header, i) =>
							<th
								key={i}
								className={cn({
									'sort-header': header.direction,
									'active': table.sortedColumn.index === header.index,
									[header.className]: header.className,
									[table.sortedColumn.direction]: (
										table.sortedColumn.index === header.index
									&& table.sortedColumn.direction
									)
								})}
								onClick={() => (header.direction ? sortByColumn(header.index) : noop)}
							>
								{intl(header.title)}
							</th>
						)}
					</tr>
				</thead>

				<tbody className="simple-table__body">
					{table.rows.map((row, i) => (
						<tr key={row['id']}>
							<td className="datetime">
								<span className="date">
									{moment(row['date']).format('DD.MM.YYYY')} {intl('at')}
									<span className="time">
										{moment(row['date']).format('HH:mm')}
									</span>
								</span>
							</td>

							<td className="admin">
								<span>{row['admin']}</span>
							</td>

							<td className="status">
								<span>{row['status']}</span>
							</td>

							<td className="affiliate">
								<Link to={`affiliates/profile/${row['affiliate_id']}`} target="_blank">
									{row['affiliate']}
								</Link>
							</td>

							<td className="amount">
								{ amount(row['amount'], row['currency']) }
							</td>

							<td className="payout-system">
								<span>{row['payout_system']}</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
			<div className="total">{intl('Total')}: {pagination.total || 0}</div>
			<Pagination pagination={pagination} gotoPage={gotoPage} />
		</div>
	);
};

Table.propTypes = propTypes;

export default Table;

// functions
const amount = (amount, currency) => (
	<span className={cn({ 'negative-amount': amount > 0, 'positive-amount': amount < 0 })}>
		{formatMoney(Math.abs(amount), true)}
		<span className="amount__currency">{getCurrencyIcon(currency)}</span>
	</span>
);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-log/payments/components/table/main.js